import { Link } from "react-router";
import styles from "./Breadcrumb.module.css";

type BreadcrumbItem = {
  label: string;
  path?: string;
};

type BreadcrumbProps = {
  items: BreadcrumbItem[];
};

function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav className={styles["breadcrumb"]} aria-label="Breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <span key={index} className={styles["breadcrumb-item"]}>
            {item.path && !isLast ? (
              <Link to={item.path} className={styles["breadcrumb-link"]}>
                {item.label}
              </Link>
            ) : (
              <span
                className={isLast ? styles["breadcrumb-current"] : ""}
                aria-current={isLast ? "page" : undefined}
              >
                {item.label}
              </span>
            )}
            {!isLast && <span className={styles["separator"]}> / </span>}
          </span>
        );
      })}
    </nav>
  );
}

export default Breadcrumb;
